import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default async function getMovimentoTipo() {
  const data = await api.get(`${URLS.MOVIMENTOS_TIPO_API}`)
  .then((resp) => resp?.data);

  return data;
}
